import { useState } from "react";
import { Link } from "react-router-dom";
import { allPhotos } from "../../../mocks/photos";

const previewPhotos = allPhotos.slice(0, 8);

export default function Gallery() {
  const [selected, setSelected] = useState<number | null>(null);
  const selectedPhoto = previewPhotos.find((p) => p.id === selected) ?? null;

  return (
    <section id="galeria" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-teal-600 text-xs font-bold tracking-[0.3em] uppercase mb-3">Nuestros trabajos</p>
          <h2 className="text-4xl font-black text-gray-900 tracking-widest">GALERÍA</h2>
          <div className="w-12 h-1 bg-teal-500 mx-auto mt-4 rounded-full" />
          <p className="text-gray-500 text-sm mt-4">{allPhotos.length} proyectos completados</p>
        </div>

        {/* Grid preview */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {previewPhotos.map((photo) => (
            <div
              key={photo.id}
              className="relative overflow-hidden rounded-xl group cursor-pointer h-56"
              onClick={() => setSelected(photo.id)}
            >
              <img
                src={photo.src}
                alt={photo.label}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-teal-900/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <span className="text-white font-semibold text-sm">{photo.label}</span>
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
                  <i className="ri-zoom-in-line text-white text-lg" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Ver todos */}
        <div className="text-center mt-12">
          <Link
            to="/galeria"
            className="inline-flex items-center gap-3 bg-teal-600 hover:bg-teal-700 text-white font-bold px-8 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-grid-fill" />
            Ver todos los proyectos ({allPhotos.length})
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>

      {/* Lightbox */}
      {selectedPhoto && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
          onClick={() => setSelected(null)}
        >
          <div
            className="relative max-w-4xl w-full rounded-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedPhoto.src}
              alt={selectedPhoto.label}
              className="w-full h-auto max-h-[80vh] object-contain bg-black"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
              <p className="text-white font-bold text-lg">{selectedPhoto.label}</p>
            </div>
            <button
              onClick={() => setSelected(null)}
              className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-black/50 hover:bg-black/80 text-white rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-lg" />
            </button>
            <button
              onClick={() => {
                const idx = previewPhotos.findIndex((p) => p.id === selected);
                setSelected(previewPhotos[(idx - 1 + previewPhotos.length) % previewPhotos.length].id);
              }}
              className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-black/50 hover:bg-black/80 text-white rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-xl" />
            </button>
            <button
              onClick={() => {
                const idx = previewPhotos.findIndex((p) => p.id === selected);
                setSelected(previewPhotos[(idx + 1) % previewPhotos.length].id);
              }}
              className="absolute right-12 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-black/50 hover:bg-black/80 text-white rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-xl" />
            </button>
          </div>
        </div>
      )}
    </section>
  );
}